import { createBrowserHistory } from 'history';


export  const browserHistory = createBrowserHistory();

// ---------------------------------------------------------------------------
// Tela atual para o HISTÓRICO DE USO (tb_user_usage_history, Mexx.Shared.Api/UsageAudit).
//
// O backend não sabe de qual tela veio um request. O front manda em dois headers:
//   X-Mexx-Screen        = path real da tela (ex.: /pt/calleds/1029292). O backend guarda o
//                          real em `screen` e a forma sem id (/calleds/{id}) em `screen_route`.
//   X-Mexx-Screen-Enter  = "1" SÓ no primeiro request depois de uma navegação. O backend gera
//                          com ele uma linha extra do tipo "screen" (tela aberta), sem request
//                          adicional do front.
//
// browserHistory.listen dispara UMA vez por navegação (diferente do MultiLanguageRoute, que
// re-renderiza a cada render do pai e contaria a mais). Nada aqui faz request; só memória.
// Sem async/await em arrow (limitação do babel 7.12 do react-scripts 4).
// ---------------------------------------------------------------------------
//   X-Mexx-Screen-Id     = uuid da VISITA, novo a cada navegação. A linha de tela e todos os
//                          requests disparados por ela levam o mesmo id: é o que permite
//                          listar "os requests filhos desta tela" no backend.
function newVisitId() {
  try {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
  } catch (e) { /* segue para o fallback */ }
  // Fallback RFC4122 v4 sem crypto.randomUUID (browsers antigos).
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}

//   X-Mexx-Screen-At     = instante da navegação (epoch ms). O backend usa como occurred_at da
//                          linha de tela, para ela vir ANTES dos requests filhos mesmo quando o
//                          request que leva o "Enter" chega ao servidor depois dos irmãos
//                          (preflight de CORS, concorrência).
let currentScreen = (window.location && window.location.pathname) || '/';
let currentVisitId = newVisitId();
let currentVisitAt = Date.now();
let screenEnterPending = true; // primeira carga da página também é "tela aberta"

browserHistory.listen((location) => {
  const next = (location && location.pathname) || '/';
  if (next !== currentScreen) {
    screenEnterPending = true;
    currentVisitId = newVisitId();
    currentVisitAt = Date.now();
  }
  currentScreen = next;
});

// Headers a anexar no request. Consome o "Enter" no primeiro request após navegar.
export function usageScreenHeaders() {
  const headers = {
    'X-Mexx-Screen': currentScreen,
    'X-Mexx-Screen-Id': currentVisitId,
    'X-Mexx-Screen-At': String(currentVisitAt),
  };
  if (screenEnterPending) {
    headers['X-Mexx-Screen-Enter'] = '1';
    screenEnterPending = false;
  }
  return headers;
}

// Liga o interceptor numa instância axios (Api, ApiReports, Api2Talk). Idempotente por instância.
export function attachUsageScreenHeaders(instance) {
  if (!instance || !instance.interceptors || instance.__usageScreenAttached) return instance;
  instance.interceptors.request.use((config) => {
    config.headers = Object.assign(config.headers || {}, usageScreenHeaders());
    return config;
  });
  instance.__usageScreenAttached = true;
  return instance;
}